module.exports = __webpack_public_path__ + "img/Background.f171b8f9.png";